export default "__VITE_ASSET__$SmE13CO__"